import {
  CHANGE_PASSWORD_BY_URL_REQUEST,
  CHANGE_PASSWORD_BY_URL_SUCCESS,
  CHANGE_PASSWORD_BY_URL_FAILURE,
  CHANGE_PASSWORD_BY_URL_RESET,
} from '../Constants/actionTypes';

import { changePasswordByUrlApi } from '../Constants/apiService';

export const resetChangePasswordByUrl = () => ({ type: CHANGE_PASSWORD_BY_URL_RESET });

/**
 * @param {{ uid:string, token:string, password:string, cnewpassword:string }} args
 */

export const changePasswordByUrl = (args) => async (dispatch) => {
  dispatch({ type: CHANGE_PASSWORD_BY_URL_REQUEST });
  try {
    await changePasswordByUrlApi(args);
    dispatch({ type: CHANGE_PASSWORD_BY_URL_SUCCESS });
  } catch (error) {
    // Map expirations/invalid tokens using status codes commonly used by backends
    const status = error?.status;
    const isExpired =
      status === 400 || status === 401 || status === 403 || status === 410 || status === 422;

    const message =
      error?.message === 'Failed to fetch' || error?.message?.includes('NetworkError')
        ? 'Unable to reach server. Please try again later.'
        : (error?.message || 'Please try again.');

    dispatch({
      type: CHANGE_PASSWORD_BY_URL_FAILURE,
      payload: { message, expired: !!isExpired },
    });
  }
};

